import { render } from "./infoPage.vue?vue&type=template&id=24d0fc1d&scoped=true"
import script from "./infoPage.vue?vue&type=script&lang=js"
export * from "./infoPage.vue?vue&type=script&lang=js"

import "./infoPage.vue?vue&type=style&index=0&id=24d0fc1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d0fc1d"]])

export default __exports__